var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPinezkaBiala(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.433,
    height: 11.302,
    viewBox: "0 0 6.433 11.302"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.429.303a.3.3 0 00-.3-.3H.303a.3.3 0 00-.3.3c0 .151 0 .415 1.105.561v4.223c-.68.318-1.105.79-1.105 1.326a.3.3 0 00.3.3h1.958a12.76 12.76 0 00.693 4.158l.251.428.267-.419a12 12 0 00.7-4.167h1.952a.3.3 0 00.3-.3c0-.536-.425-1.008-1.105-1.326V.864c1.11-.145 1.11-.41 1.11-.561zm-4.721.62c.4.028.894.044 1.5.044s1.1-.016 1.5-.044v3.941a5.86 5.86 0 00-3.009 0zm1.509 8.815a23.559 23.559 0 01-.353-3.022h.7a23.42 23.42 0 01-.343 3.023zm2.5-3.629h-5a4.167 4.167 0 015 0z",
    fill: "#fff"
  })));
}

export default SvgPinezkaBiala;